import { VOverlay } from 'vuetify/lib/components/VOverlay';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HpHV2'),_c(VOverlay,{attrs:{"value":_vm.dialog,"opacity":"0.6","z-index":2000}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }